import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {api} from "../../api";
import {IWindow} from "../../index";
import {Field} from "../form/Field";
import {Col, Row} from "reactstrap";
import {Select} from "../form/fields/Select";

const IWindow: IWindow = (window as IWindow);

export class ResultSummaryFormData {
    @observable name = '';
}

export class ResultSummaryForm extends CrudForm {
    modelName = 'ResultSummary';

    renderFields() {
        return (
            <>

            </>
        );
    }
}

export class ResultSummaryFilterForm {
    @observable name = '';
    @observable election_id = null;
    @observable election_position_id = null;
    @observable user_party_id = IWindow.initialState.user.party_id;
    @observable party_id = null;
    @observable candidate_id = null;
    @observable level = null;
    @observable state_id = null; 
    @observable senatorial_district_id = null;
    @observable federal_constituency_id = null;
    @observable local_government_area_id = null;
    @observable state_constituency_id = null;
    @observable ward_id = null;
    @observable page = null;
}

export class ResultSummaryList extends CrudList {
    modelName = 'ResultSummary';
    defaultSortColumn = 'position_id';
    defaultSortDirection = 'asc';
    @observable is_load_done_election: string = 'n';
    @observable is_load_done: string = 'n';

    renderColumn = (value: any, compareValue: any, columnName: any) => {
        if (columnName == 'federal' &&
            (this.filterFormStore.getValue('local_government_area_id') ||
                this.filterFormStore.getValue('ward_id') ||
                this.filterFormStore.getValue('state_id'))) {
            return value;
        } else if (['state', 'senatorial_district',
                'federal_constituency',
                'state_constituency'].includes(columnName) &&
            (this.filterFormStore.getValue('local_government_area_id') ||
                this.filterFormStore.getValue('ward_id'))) {
            return value;
        } else if (columnName == 'lga' && this.filterFormStore.getValue('ward_id')) {
            return value;
        } else {
            return <span className={value != compareValue ? 'text-danger' : ''}>{value}</span>
        }
    }

    colums() {
        return [
            {
                name: "name",
                label: "Name",
            },
            {
                name: "party_name",
                label: "Party",
            },
            {
                name: "position.name",
                label: "Position",
            },
            {
                name: "pu_count",
                label: "PU Count",
            },
            {
                name: "pu_total_votes",
                label: "PU votes",
            },
            {
                name: "ward_count",
                label: "Ward Count",
            },
            {
                name: "ward_total_votes",
                label: "Ward votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.pu_total_votes, 'ward')}
                        </>
                    )
                }
            },
            {
                name: "lga_count",
                label: "Lga Count",
            },
            {
                name: "lga_total_votes",
                label: "Lga votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.ward_total_votes, 'lga')}
                        </>
                    )
                }
            },
            {
                name: "state_count",
                label: "State Count",
            },
            {
                name: "state_total_votes",
                label: "State votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.lga_total_votes, 'state')}
                        </>
                    )
                }
            },

            {
                name: "federal_total_votes",
                label: "Federal votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.state_total_votes, 'federal')}
                        </>
                    )
                }
            },
            {
                name: "sd_count",
                label: "Sen Des. Count",
            },
            {
                name: "sd_total_votes",
                label: "Sen. Des. votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.lga_total_votes, 'senatorial_district')}
                        </>
                    )
                }
            },
            {
                name: "fc_count",
                label: "Fed. Cons. Count",
            },
            {
                name: "fc_total_votes",
                label: "Fed. Cons. votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.lga_total_votes, 'federal_constituency')}
                        </>
                    )
                }
            },
            {
                name: "sc_count",
                label: "State. Cons. Count",
            },
            {
                name: "sc_total_votes",
                label: "State. Cons. votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.ward_total_votes, 'state_constituency')}
                        </>
                    )
                }
            },
        ];
    }

    idColumn() {
        return '';
    }

    actions() {
        return {}
    }

    stateDropDown() {
        return <Col md={2}>
            <Field
                key={'state_id_' + this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('election_id')
                }
                name="state_id"
                placeholder="Select State"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('senatorial_district_id', null);
                    this.filterFormStore.setValue('federal_constituency_id', null);
                    this.filterFormStore.setValue('local_government_area_id', null);
                    this.filterFormStore.setValue('state_constituency_id', null);
                    this.filterFormStore.setValue('ward_id', null);
                }}
            />
        </Col>;
    };

    lgaDropDown() {
        return <Col md={2}>
            <Field
                key={'local_government_area_id_' +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('senatorial_district_id') +
                this.filterFormStore.getValue('federal_constituency_id')
                }
                name="local_government_area_id"
                placeholder="Select LGA"
                component={Select}
                loadOptions={() => {
                    return api.localGovernmentArea.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                            federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('ward_id', null);
                }}
            />
        </Col>;
    };

    wardsDropDown() {
        return <Col md={2}>
            <Field
                key={"ward_id_" +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('local_government_area_id') +
                this.filterFormStore.getValue('state_constituency_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('user_party_id')
                }
                name="ward_id"
                placeholder="Select Ward"
                component={Select}
                loadOptions={() => {
                    return api.ward.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                            state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
            />
        </Col>;
    }

    senatorialDistrictDropDown() {
        return this.filterFormStore.getValue('level') === 'senatorial_district' ?
            <Col md={2}>
                <Field
                    key={'senatorial_district_id_' +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);

                    }}
                />
            </Col> : '';
    }

    federalConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'federal_constituency' ?
            <Col md={2}>
                <Field
                    key={'federal_constituency_id_' +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col> : '';
    }

    stateConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'state_constituency' ?
            <Col md={2}>
                <Field
                    key={'state_constituency_id_' +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);

                    }}
                />
            </Col> : '';
    }

    renderTable() {
        if (this.filterFormStore.getValue('election_id')) {
            return super.renderTable();
        }
        return <>{'Please select election first!'}</>;
    }
    onLoadElectionsData = () => {
        return api.election.getListAction({
            filters: {
                party_id: IWindow.initialState.user.party_id,
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done_election == "n")
                    this.filterFormStore.setValue('election_id', data[0].id);
            }
            this.is_load_done_election = "y";
            return data;
        });
    };

    onLoadElectionsParty = () => {
        return api.party.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                include_competitor_party: 1
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done == "n")
                    this.filterFormStore.setValue('party_id', data[0].id);
            }
            this.is_load_done = "y";
            return data;
        });
    };

    renderFilters() {
        return (
            <Row className="form-row">
                <Col md={2}>
                    <Field
                         key={'filter-election' + this.filterFormStore.getValue('election_id')}
                        placeholder="Select Election"
                        name="election_id"
                        component={Select} 
                        required={true}
                        loadOptions={this.onLoadElectionsData}
                       /* loadOptions={() => {
                            return api.election.getListAction({
                                filters: {
                                    party_id: IWindow.initialState.user.party_id,
                                }
                            }).then((data: any) => {
                                if (data && data.length) {
                                    this.filterFormStore.setValue('election_id', data[0].id);
                                }
                                return data;
                            });
                        }}*/
                        store={this.filterFormStore}
                    />
                </Col>

                {this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'party_id_' + this.filterFormStore.getValue('election_id')} 
                           
                            name="party_id"
                            placeholder="Select Party"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_id')}
                            required={true}
                          //  loadOptions={this.onLoadElectionsParty}
                              loadOptions={() => {
                                return api.party.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        include_competitor_party: 1
                                    }
                                }).then((data: any) => {
                                    return data.data;
                                });
                            }} 
                            store={this.filterFormStore}
                            onChange={() => {
                                this.filterFormStore.setValue('candidate_id', null);
                            }}
                        />
                    </Col> : ''
                }

                {this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'election_position_id_' +
                            this.filterFormStore.getValue('election_id') +
                            this.filterFormStore.getValue('user_party_id') +
                            this.filterFormStore.getValue('party_id')
                            }
                            name="election_position_id"
                            placeholder="Select Position"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_id')}
                            required={true}
                            loadOptions={() => {
                                return api.electionPosition.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        party_id: IWindow.initialState.user.party_id,
                                        other_party_id: this.filterFormStore.getValue('party_id'),
                                        search_competitor: 1,
                                    }
                                });
                            }}
                            returnObject={true}
                            extraKey={'level'}
                            store={this.filterFormStore}
                            onChange={(item: any) => {
                                this.filterFormStore.setValue('level', null);
                                if (item) {
                                    this.filterFormStore.setValue('level', item.extraKey);
                                }
                                this.filterFormStore.setValue('state_id', null);
                                this.filterFormStore.setValue('senatorial_district_id', null);
                                this.filterFormStore.setValue('federal_constituency_id', null);
                                this.filterFormStore.setValue('local_government_area_id', null);
                                this.filterFormStore.setValue('state_constituency_id', null);
                                this.filterFormStore.setValue('ward_id', null);
                            }}
                        />
                    </Col> : ''
                }

                {this.filterFormStore.getValue('election_position_id') ?
                    <Col md={2}>
                        <Field
                            key={'candidate_filter_summary_' +
                            this.filterFormStore.getValue('party_id') + '_election_id' +
                            this.filterFormStore.getValue('election_id') + '_election_position_id' +
                            this.filterFormStore.getValue('election_position_id')
                            }
                            name="candidate_id"
                            placeholder="Select Candidate"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_position_id')}
                            required={true}
                            loadOptions={() => {
                                return api.candidate.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        party_id: this.filterFormStore.getValue('party_id'),
                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                    }
                                });
                            }}
                            store={this.filterFormStore}
                        />
                    </Col> : ''
                }
                { this.filterFormStore.getValue('level')  !== 'polling_unit'?
                    <>
                    {this.stateDropDown()}
                    {this.senatorialDistrictDropDown()}
                    {this.federalConstituencyDropDown()}
                    {this.lgaDropDown()}
                    {this.stateConstituencyDropDown()}
                    {this.wardsDropDown()}
                    </> : ''
                }

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
        );
    }
}

export class ResultSummaryPage extends CrudPage {
    modelName = 'ResultSummary';
    actionButton = false;
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ResultSummaryPage_Backup_Nov22.tsx